import { supabase } from "@/lib/supabase";

export interface ReorderItem {
  sku: string;
  name: string;
  available: number;
  reorder_point: number;
  recommended_order_qty: number;
  action: string;
}

export interface AiTaskResult {
  task: string;
  deterministic: boolean;
  provider: string | null;
  model: string | null;
  requires_approval: boolean;
  usage: { input_tokens: number; output_tokens: number; estimated_cost: number };
  /** Top-level orchestrator flags used for truthful enrichment UX (non-sensitive). */
  ai_disabled?: boolean;
  budget_blocked?: boolean;
  external_isolated?: boolean;
  provider_key_present?: boolean;
  fallback_error?: string | null;
  deduplicated?: boolean;
  result: {
    summary?: string;
    needs_reorder?: ReorderItem[];
    [key: string]: unknown;
  };
}

export async function runAiTask(
  taskId: string,
  params?: Record<string, unknown>,
  orgId?: string,
): Promise<AiTaskResult> {
  const requestId = crypto.randomUUID();
  const { data, error } = await supabase.functions.invoke("ai-orchestrator", {
    body: { taskId, params, orgId, requestId },
  });
  if (error) throw error;
  return data as AiTaskResult;
}